import { catchError, map, Observable, timeout } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  AppActionTypes,
  Order,
  OrderAction,
  OrderActionEvent,
  OrderActionType,
} from 'src/app/shared';
import { ConfigService, HTTP_REQUESTS_TIMEOUT } from 'src/app/core';

@Injectable({
  providedIn: 'root',
})
export class OrderActionHandlerService extends EventEmitter<
  OrderActionEvent<Order | boolean>
> {
  constructor(
    private http: HttpClient,
    private config: ConfigService,

    private snake: MatSnackBar
  ) {
    super();
  }

  public run(orderAction: OrderAction): Observable<Order | boolean> {
    switch (orderAction.type) {
      case 'decreaseCopy':
        return this.decreaseCopy(orderAction.id);

      case 'increaseCopy':
        return this.increaseCopy(orderAction.id);
    }
  }

  increaseCopy(id: number): Observable<Order | boolean> {
    const url = this.generateUrl(id, 'increaseCopy');
    return this.sendRequest<Order>(url);
  }

  decreaseCopy(id: number): Observable<Order | boolean> {
    const url = this.generateUrl(id, 'decreaseCopy');
    return this.sendRequest<Order>(url);
  }

  private generateUrl(id: number, actionType: OrderActionType): string {
    return this.config
      .getUrl('shoppingCart.action')
      .replace(':type', actionType)
      .replace(':id', id + '');
  }

  private sendRequest<T extends Order>(url: string): Observable<T> {
    return this.http.put<T>(url, {}, { withCredentials: true }).pipe(
      timeout(HTTP_REQUESTS_TIMEOUT),
      map((value: T, index: number) => {
        this.emit({ data: value });
        return value;
      }),
      catchError((err, caught) => {
        if (err instanceof HttpErrorResponse) {
          this.snake.open('مشکل در ارتباط با سرور', '', { duration: 1000 });
          throw err;
        } else {
          this.snake.open('مشکل نا شناخته در سرور', '', { duration: 1000 });
          throw err;
        }
      })
    );
  }
}
